
import React, { useState, useEffect } from "react";
import { FaTimesCircle } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const RaiseRejectedVoice = () => {
  const navigate = useNavigate();
  const [voices, setVoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rejectedCount, setRejectedCount] = useState(0);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const totalPages = Math.ceil(voices.length / rowsPerPage);

  useEffect(() => {
    const fetchRejectedVoices = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/get/rejected/ads/by/reporter`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        console.log("Fetched Rejected Voices:", response);
        const data = response.data.data || response.data;
        const rejectedVoices = Array.isArray(data) ? data : [];
        setVoices(rejectedVoices);
        setRejectedCount(rejectedVoices.length);
      } catch (error) {
        console.error("Error fetching rejected voices:", error);
        // toast.error("Failed to load rejected voices");
      } finally {
        setLoading(false);
      }
    };
    fetchRejectedVoices();
  }, []);

  // Pagination handlers
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Calculate visible rows for current page
  const paginatedVoices = [...voices].reverse().slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  return (
    <div className="p-6">
      <ToastContainer position="top-right" autoClose={3000} />
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-4">
        <h1 className="text-2xl font-bold text-gray-800">Rejected Voices</h1>
        <div className="flex flex-wrap gap-2">
          <button
            className="flex-1 sm:flex-none px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 font-semibold transition-colors text-sm sm:text-base shadow"
            onClick={() => navigate("/admin/runningvoice")}
          >
            Accepted By Reporter
          </button>
          <button
            className="px-3 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600 font-semibold"
            onClick={() => navigate("/admin/pendingvoice")}
          >
            Pending
          </button>
          <button
            className="px-3 py-2 bg-green-500 text-white rounded hover:bg-green-600 font-semibold"
            onClick={() => navigate("/admin/approvedvoice")}
          >
            Approved
          </button>
          <button
            className="px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 font-semibold"
            onClick={() => navigate("/admin/runningvoice")}
          >
            Running
          </button>
        </div>
      </div>
      {/* Stats */}
      <div className="mb-8">
        <div className="bg-red-500 p-6 rounded-xl shadow-lg text-white">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-sm font-medium opacity-80">Rejected Voices</p>
              <p className="text-2xl font-bold mt-1">{rejectedCount}</p>
            </div>
            <FaTimesCircle className="w-10 h-10 opacity-80" />
          </div>
        </div>
      </div>
      {/* Content */}
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-500"></div>
        </div>
      ) : voices.length === 0 ? (
        <div className="bg-white rounded-xl shadow-sm p-8 text-center">
          <FaTimesCircle className="w-16 h-16 mx-auto text-gray-300 mb-4" />
          <h3 className="text-xl font-semibold text-gray-700 mb-2">
            No Rejected Voices
          </h3>
          <p className="text-gray-500">You don't have any rejected voices.</p>
        </div>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white rounded-xl shadow-sm border border-gray-100">
              <thead>
                <tr className="bg-red-100 text-red-800">
                  <th className="py-3 px-4 text-left">RYV ID</th>
                  <th className="py-3 px-4 text-left">Target Audience</th>
                  <th className="py-3 px-4 text-left">iinsaf ID</th>
                  <th className="py-3 px-4 text-left">Reporter Name</th>
                  <th className="py-3 px-4 text-left">Rejection Reason</th>
                  <th className="py-3 px-4 text-left">Submitted</th>
                </tr>
              </thead>
              <tbody>
                {paginatedVoices.map((voice) => (
                  <tr key={voice.id || voice._id} className="border-b hover:bg-red-50">
                    <td className="py-3 px-4">{voice.adId?._id || voice.adId || "N/A"}</td>
                    <td className="py-3 px-4">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${voice.adId?.targetUserType === "reporter"
                          ? "bg-blue-100 text-blue-800"
                          : voice.adId?.targetUserType === "influencer"
                            ? "bg-purple-100 text-purple-800"
                            : voice.adId?.targetUserType === "both"
                              ? "bg-green-100 text-green-800"
                              : "bg-gray-100 text-gray-800"
                        }`}>
                        {voice.adId?.targetUserType === "reporter" ? "Reporters Only" :
                          voice.adId?.targetUserType === "influencer" ? "Influencers Only" :
                            voice.adId?.targetUserType === "both" ? "Both" : "Not Specified"}
                      </span>
                    </td>
                    <td className="py-3 px-4 text-sm text-gray-900">
                      {voice.iinsafId || "N/A"}
                    </td>
                    <td className="py-3 px-4">{voice.reporterId?.name || "N/A"}</td>
                    <td className="py-3 px-4 text-sm text-gray-900">
                      {voice.rejectionNote || "No reason provided"}
                    </td>
                    <td className="px-4 py-1 text-sm text-gray-900">{voice.submittedAt ? new Date(voice.submittedAt).toLocaleString() : "N/A"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div className="flex justify-center mt-6">
              <nav className="inline-flex flex-wrap items-center gap-2">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className={`px-3 py-1 rounded border border-yellow-400 text-yellow-800 bg-white hover:bg-yellow-100 transition-colors ${currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''}`}
                  aria-label="Previous Page"
                >
                  Previous
                </button>
                {/* Page Numbers */}
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    className={`px-3 py-1 rounded border border-yellow-400 font-semibold transition-colors ${currentPage === page ? 'bg-yellow-300 text-yellow-900' : 'bg-white text-yellow-800 hover:bg-yellow-100'}`}
                    aria-current={currentPage === page ? 'page' : undefined}
                  >
                    {page}
                  </button>
                ))}
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className={`px-3 py-1 rounded border border-yellow-400 text-yellow-800 bg-white hover:bg-yellow-100 transition-colors ${currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : ''}`}
                  aria-label="Next Page"
                >
                  Next
                </button>
              </nav>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default RaiseRejectedVoice;
